import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { RouterModule } from '@angular/router';

@Component({
    selector: 'app-manage-paddocks',
    templateUrl: './manage-paddocks.component.html',
    styleUrls: ['./manage-paddocks.component.css'],
    standalone: true,
    imports:[CommonModule,RouterModule]
})
export class ManagePaddocksComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
